export default __webpack_public_path__ + "static/media/nequi.aa567909.svg";